import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpRequest, HttpEvent } from '@angular/common/http';
import { DictionaryRequest } from '../../../models/dictionary-request.model';
import { EndpointService } from '../endpoint/endpoint.service';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../../models/configuration.model';
import { SetupService } from '../setup/setup.service';
import { ListOutputDTO } from '../../../models/ListDTO.model';

@Injectable()
export class BafAgentService {
  private readonly apiUrl: string;
  private readonly minimalOptions: object;
  private readonly uploadOptions: object;
  private readonly standardOptions: object;
  private readonly postOptions: object;
  private readonly jsonOptions: object;

  constructor(
    private http: HttpClient,
    private setup: SetupService,
    private endpoint: EndpointService
  ) {
    this.apiUrl = setup.baseUrl;
    this.minimalOptions = { withCredentials: true };
    this.uploadOptions = { withCredentials: true, reportProgress: true };
    this.standardOptions = this.prepareGetOptions({});
    this.postOptions = this.preparePostOptions();
    this.jsonOptions = this.prepareJsonOptions();
  }

  getUserState(): Observable<any> {
    return this.http.get(this.endpoint.authenticationCheckUrl, this.standardOptions);
  }

  //not working
  logout(): Observable<any> {
    return this.http.post(this.endpoint.authenticationInvalidateUrl, {}, this.postOptions);
  }

  get logoutUrl(): string {
    return this.endpoint.authenticationInvalidateUrl;
  }

  loadUserProfile(): Observable<any> {
    return this.http.get(this.endpoint.loadUserValueUrl, this.standardOptions);
  }

  loadUserValue(key: string): Observable<string> {
    return this.http.get<string>(
      this.endpoint.loadUserValueUrl + '?key=' + key,
      this.standardOptions
    );
  }

  saveUserValue(key: string, value: string): Observable<any> {
    const body = {
      key: key,
      value: value
    };

    return this.http.post(this.endpoint.saveUserValueUrl, body, this.jsonOptions);
  }

  clearUser(): Observable<boolean> {
    return this.http.get<boolean>(this.endpoint.clearUserUrl, this.standardOptions);
  }

  getConfiguration(): Observable<Configuration> {
    return this.http.get<Configuration>(this.endpoint.configurationUrl, this.standardOptions);
  }

  getDictionary(request: DictionaryRequest): Observable<any> {
    const query = this.encodeValues(request);

    return this.http.get<any>(this.endpoint.comboValuesUrl + '?' + query, this.standardOptions);
  }

  downloadFile(path: string, fileName: string) {
    window.open(this.endpoint.downloadFileUrl + '?path=' + path + '&fileName=' + fileName);
  }

  downloadResource(url: string) {
    window.open(url);
  }

  dlFile(data: Response) {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }

  downloadFileX() {
    return this.http.get(this.endpoint.downloadFileUrl, this.minimalOptions);
  }

  getFile() {
    this.downloadFileX().subscribe(data => {
      const blob = new Blob([data], {
        type: 'application/zip'
      });
      const url = window.URL.createObjectURL(blob);
    });
  }

  download() {
    this.http
      .post(this.endpoint.downloadFileUrl, '', {
        headers: new HttpHeaders({ 'Content-type': 'application/json' }),
        observe: 'body',
        responseType: 'blob',
        withCredentials: true
      })
      .subscribe(response => {
        // const blob = new Blob([response.blob()], { type: 'application/zip' });
        const filename = 'file.zip';
      });
  }

  getView(elementId, elementViewId, featureId: string): Observable<any> {
    const body = {
      elementId: elementId,
      elementViewId: elementViewId,
      featureId: featureId,
      useDictionaryData: false
    };

    return this.http.post(this.endpoint.loadViewUrl, body, this.postOptions);
  }

  uploadData(form: FormData): Observable<HttpEvent<FormData>> {
    const request = new HttpRequest(
      'POST',
      this.endpoint.executeAssemblyActionUrl,
      form,
      this.uploadOptions
    );
    return this.http.request(request);
  }

  executeAssemblyAction(form: FormData, options: object): Observable<any> {
    return this.http.post(this.endpoint.executeAssemblyActionUrl, form, {
      ...this.minimalOptions,
      ...options
    });
  }

  executeParameterizedAction(data: any): Observable<any> {
    return this.http.post(
      this.endpoint.executeParameterizedActionUrl,
      this.encodeValues(data),
      this.postOptions
    );
  }

  saveData(elementId, elementViewId, featureId, data: string): Observable<any> {
    const body = {
      elementId: elementId,
      elementViewId: elementViewId,
      featureId: featureId,
      data: data,
      useDictionaryData: false
    };

    return this.http.post(this.endpoint.saveDataUrl, this.encodeValues(body), this.postOptions);
  }

  private handleError(error: any) {
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

  getDataGrid(): Observable<ListOutputDTO> {
    const body =
      'elementId=ELEMENT.KLIENCI&elementViewId=LISTA_KLIENTOW&page=1&start=0&limit=200' +
      '&sort.property=KLIENCI.NAZWA&sort.direction=DESC';
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.post<ListOutputDTO>(this.apiUrl + 'Data/', body, options);
  }

  getDirectoryValue(
    attributeId: string,
    comboItemId: string,
    elementId: string,
    elementViewId: string
  ): Observable<string> {
    return this.http.get<string>(
      this.apiUrl +
        'Data/GetComboItemName' +
        '?attributeId=' +
        attributeId +
        '&comboItemId=' +
        comboItemId +
        '&elementId=' +
        elementId +
        '&elementViewId=' +
        elementViewId,
      { withCredentials: true }
    );
  }

  private prepareGetOptions(request: any): object {
    return {
      params: this.prepareParams(request),
      withCredentials: true
    };
  }

  private preparePostOptions(): object {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });

    return {
      headers: headers,
      withCredentials: true
    };
  }

  private prepareJsonOptions(): object {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    });

    return {
      headers: headers,
      withCredentials: true
    };
  }

  private prepareParams(request: any): HttpParams {
    const params = new HttpParams();

    for (const key in request) {
      if (request.hasOwnProperty(key)) {
        params.set(key, request[key]);
      }
    }

    return params;
  }

  private encodeValues(data: any): string {
    // jest jakiś problem z automatyczną detekcją danych w usłudze http
    let body = '';

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (body) {
          body += '&';
        }
        body += `${key}=${data[key]}`;
      }
    }

    return body;
  }
  NotificationCount(data: string[]): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    });
    const body = {
      name: 'LiczbaZawiadomien',
      queryParameters: data
    };
    return this.http.post(
      this.endpoint.notificationCountUrl,
      this.encodeValues(body),
      this.postOptions
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/baf-agent/baf-agent.service.ts